import { render } from "./InventoryLayout.vue?vue&type=template&id=58eec5c9&scoped=true"
import script from "./InventoryLayout.vue?vue&type=script&lang=js"
export * from "./InventoryLayout.vue?vue&type=script&lang=js"

import "./InventoryLayout.vue?vue&type=style&index=0&id=58eec5c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58eec5c9"]])

export default __exports__